import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Servicos_disponiveis from "./pages/Servicos_disponiveis";
import Meus_servicos from "./pages/Meus_servicos";
import Pagamentos from "./pages/Pagamentos";
import Perfil from "./pages/Perfil";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import { AuthContext } from "./context/AuthContext";

const RotaPrivada = ({ children }) => {
  const { usuario, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'
      }}>
        <h2>Carregando...</h2>
      </div>
    );
  }

  return usuario ? children : <Navigate to="/login" replace />;
};

function App() {
  const { usuario, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'
      }}>
        <h2>Carregando...</h2>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {usuario && <Sidebar />}
      <div style={{ flex: 1, padding: "20px" }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />

          {/* Rotas protegidas */}
          <Route path="/" element={<RotaPrivada><Servicos_disponiveis /></RotaPrivada>} />
          <Route path="/Meus_servicos" element={<RotaPrivada><Meus_servicos /></RotaPrivada>} />
          <Route path="/Pagamentos" element={<RotaPrivada><Pagamentos /></RotaPrivada>} />
          <Route path="/Perfil" element={<RotaPrivada><Perfil /></RotaPrivada>} />
          {/* Rota não encontrada */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
